import React from "react";
import {
  SiReact,
  SiJavascript,
  SiTypescript,
  SiNodedotjs,
  SiExpress,
  SiPostgresql,
  SiMongodb,
  SiTailwindcss,
  SiBootstrap,
  SiHtml5,
  SiCss3,
} from "react-icons/si";

const techList = [
  { Icon: SiReact,       name: "React",       color: "#61dafb" },
  { Icon: SiJavascript,  name: "JavaScript",  color: "#f7df1e" },
  { Icon: SiTypescript,  name: "TypeScript",  color: "#3178c6" },
  { Icon: SiNodedotjs,   name: "Node.js",     color: "#339933" },
  { Icon: SiExpress,     name: "Express",     color: "#d0d0d0" },
  { Icon: SiPostgresql,  name: "PostgreSQL",  color: "#4169e1" },
  { Icon: SiMongodb,     name: "MongoDB",     color: "#47a248" },
  { Icon: SiTailwindcss, name: "Tailwind",    color: "#06b6d4" },
  { Icon: SiBootstrap,   name: "Bootstrap",   color: "#7952b3" },
  { Icon: SiHtml5,       name: "HTML5",       color: "#e34f26" },
  { Icon: SiCss3,        name: "CSS3",        color: "#1572b6" },
];

function Techstack() {
  return (
    <div className="tech-icon-grid">
      {techList.map(({ Icon, name, color }) => (
        <div
          key={name}
          className="tech-icon-item"
          style={{ "--brand-color": color }}
        >
          <Icon />
          <span className="tech-icon-label">{name}</span>
        </div>
      ))}
    </div>
  );
}

export default Techstack;
